import { Globe, Smartphone, Cloud, ShieldCheck, Bot, MessageSquare } from "lucide-react";

export const SITE = {
  name: "RICHIE RICH",
  tagline: "Enterprise IT Solutions",
  email: "contact@richierich.info",
  phoneDisplay: "+91 70603 71403",
  phoneRaw: "917060371403",
  address: "Delhi, India",
  copyright: "© 2026 RICHIE RICH All Rights Reserved",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.phoneRaw}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MSG =
  "Hello RICHIE RICH Team, I want to inquire about IT services for my business.";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1781246212288-7fa538344718?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBJVCUyMGNvbXBhbnklMjBkZXZlbG9wZXJzJTIwdGVjaCUyMG9mZmljZSUyMHRlYW18ZW58MHx8fHwxNzkwNDQ0MjEzfDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1789388227187-62020089c359?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBJVCUyMGNvbXBhbnklMjBkZXZlbG9wZXJzJTIwdGVjaCUyMG9mZmljZSUyMHRlYW18ZW58MHx8fHwxNzkwNDQ0MjEzfDA&ixlib=rb-4.1.0&q=85",
  developer: "https://images.unsplash.com/photo-1758874383467-9aead920c794?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxzb2Z0d2FyZSUyMGVuZ2luZWVyJTIwY29kaW5nJTIwbGFwdG9wJTIwbW9kZXJuJTIwb2ZmaWNlfGVufDB8fHx8MTc5MDQ0NDIyMXww&ixlib=rb-4.1.0&q=85",
  cloud: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwY2xvdWQlMjBjb21wdXRpbmclMjBzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwaW5mcmFzdHJ1Y3R1cmV8ZW58MHx8fHwxNzkwNDQ0MjEzfDA&ixlib=rb-4.1.0&q=85",
  security: "https://images.unsplash.com/photo-1662638600476-d563fffbb072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwY2xvdWQlMjBjb21wdXRpbmclMjBzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwaW5mcmFzdHJ1Y3R1cmV8ZW58MHx8fHwxNzkwNDQ0MjEzfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "web-development",
    icon: Globe,
    title: "Web Development",
    short: "High-performance business websites, portals and e-commerce platforms built on modern stacks.",
    points: ["Corporate & e-commerce websites", "React / Next.js engineering", "SEO-ready, standards-compliant builds", "CMS & admin dashboards"],
  },
  {
    id: "mobile-apps",
    icon: Smartphone,
    title: "Mobile App Development",
    short: "Native-quality Android & iOS apps designed for scale, speed and delightful user experience.",
    points: ["Android & iOS applications", "Cross-platform (Flutter / React Native)", "Play Store & App Store deployment", "Push notifications & analytics"],
  },
  {
    id: "cloud-devops",
    icon: Cloud,
    title: "Cloud & DevOps",
    short: "Cloud infrastructure, migration and CI/CD automation on AWS, Azure and Google Cloud.",
    points: ["AWS / Azure / GCP architecture", "Docker & Kubernetes", "CI/CD pipelines", "99.9% uptime SLA monitoring"],
  },
  {
    id: "cybersecurity",
    icon: ShieldCheck,
    title: "Cybersecurity",
    short: "Security audits, penetration testing and compliance hardening for your digital assets.",
    points: ["Vulnerability assessment", "Penetration testing", "ISO 27001-aligned practices", "Data protection & encryption"],
  },
  {
    id: "ai-automation",
    icon: Bot,
    title: "AI & Automation",
    short: "Intelligent chatbots, workflow automation and data pipelines that cut operational cost.",
    points: ["AI chatbots & assistants", "Business process automation", "Data pipelines & dashboards", "ML model integration"],
  },
  {
    id: "whatsapp-api",
    icon: MessageSquare,
    title: "WhatsApp Business API",
    short: "Official WhatsApp Business API setup, onboarding and messaging automation for growing businesses.",
    points: ["Official WhatsApp API onboarding", "Broadcast & template messaging", "CRM & chatbot integration", "Dedicated account support"],
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact Us" },
];
